import { ResolvedUIConfig } from 'components/forms/jsonForms/resolveAutocompleteOptions';
import { FieldGroupInline } from './FieldGroupInline';
import { FieldGroupTabs } from './FieldGroupTabs';

type FieldGroupType = 'tabs' | 'tab' | 'inlineFields';

type FieldGroupProps = {
    name: string;
    fields: ResolvedUIConfig[];
    displayAs: FieldGroupType;
    label?: string;
    help?: string;
    data: Record<string, string>;
    autoFocus: boolean;
    disabled: boolean;
    menuPortalTarget?: HTMLElement | null;
}

export const FieldGroup: React.FC<FieldGroupProps> = ({ 
    name, 
    displayAs, 
    ...fieldGroupProps 
}) => {
    if (displayAs === 'tabs') {
        return (
            <FieldGroupTabs
                key={name}  
                {...fieldGroupProps}
            />
        );
    }
    
    return (
        <FieldGroupInline
            key={name}  
            {...fieldGroupProps}
        />
    );
};
